import Card from '../../components/Card/Card';
import PageTitle from '../../components/Pagetitle/Pagetitle';
import Tabs from '../../components/Tabs/Tabs';
import UsersTable from '../../components/tables/UsersTable/UsersTable';
import Button from '@/components/Button/Button';
import MemberTable from '@/components/tables/MemberTable';
import InviteTable from '@/components/tables/InviteTable';
import PlaceholderTable from '@/components/tables/PlaceholderTable/PlaceholderTable';
import { mapActions, mapGetters } from 'vuex';
import check from '@/utils/FeatureChecker';
import Invite from '@/models/core/Invite';
import Membership from '@/models/core/Membership';
import Context from '@/models/Context';
import Feature from '@/models/Feature';

export default {
  name: 'users',
  components: {
    PageTitle,
    Card,
    Tabs,
    Button,
    UsersTable,
    MemberTable,
    InviteTable,
    PlaceholderTable
  },
  props: [],
  data() {
    return {
      tabData: [
        { name: 'Active users', slug: 'users', active: true },
        { name: 'Pending invites', slug: 'invites' }
      ],
      selectedTab: { name: 'Active users', slug: 'users' },
      openModal: false
    };
  },
  computed: {
    teamMembers: function() {
      if (!this.isLoading) {
        return Membership.query()
          .with('team')
          .with('user')
          .whereHas('team', query => {
            query.where(team => {
              return team.domain === Context.query().first().domain;
            });
          })
          .all();
      } else {
        return null;
      }
    },

    teamInvites: function() {
      if (!this.isLoading) {
        return Invite.all();
      } else {
        return null;
      }
    },

    isLoading: function() {
      return this._isLoading();
    }
  },
  beforeMount() {
    this._members();
    this._invites();
    this._groups();
  },
  mounted() {},
  methods: {
    ...mapActions({
      _groups: 'entities/groups/findForTeam',
      _members: 'entities/memberships/findForTeam',
      _invites: 'entities/invites/findForTeam',
      _checkFeature: 'entities/features/checkFeature'
    }),
    ...mapGetters({
      _isLoading: 'isLoading'
    }),
    createInvite() {
      this.openModal = true;
      this.selectedTab = { name: 'Pending invites', slug: 'invites' };
    },
    resetOpenModal() {
      this.openModal = false;
    },
    refresh() {
      this._members(true);
    }
  }
};
